import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { observer } from 'mobx-react';

import { DefaultAppProps } from '../App';

import { makeStyles, StyleRules, MakeStylesHook } from '@egr/xbox/utils/tss-react';

type ViewContainerClasses = 'root' | 'variantCatalog' | 'variantArticle' | 'fullscreen';

function getViewContainerStyles(theme: Theme): StyleRules<ViewContainerClasses> {
    return {
        root: {
            width: '100%',
            position: 'relative',
            top: 0,
            left: 0,
            height: '100%',
        },
        variantCatalog: {
            [theme.breakpoints.up('sm')]: {
                top: 30,
                height: 'calc(100% - 66px)',
            }
        },
        variantArticle: {
            [theme.breakpoints.up('sm')]: {
                top: 34,
                height: 'calc(100% - 70px)',
            }
        },
        fullscreen: {
            maxWidth: '100% !important',
        }
    };
}

const useViewContainerStyles: MakeStylesHook<ViewContainerClasses> = makeStyles({ name: 'ViewContainer' })(getViewContainerStyles);

export const ViewContainer: React.FC<DefaultAppProps> = observer(
    (props: React.PropsWithChildren<DefaultAppProps>) => {
        const { classes } = useViewContainerStyles();

        return (
            <div className={classes.root}>
                {props.children}
            </div>
        );
    }
);
